import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AuthState {
  accessToken?: string
  refreshToken?: string
}

const initialState: AuthState = {
  accessToken: window.sessionStorage.getItem('accessToken')
    || undefined,
  refreshToken: window.localStorage.getItem('refreshToken')
    || window.sessionStorage.getItem('refreshToken')
    || undefined,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.accessToken = undefined;
      state.refreshToken = undefined;
      window.sessionStorage.removeItem('accessToken')
      window.sessionStorage.removeItem('refreshToken')
      window.localStorage.removeItem('refreshToken')
    },
    refresh: (state, { payload }: PayloadAction<AuthState & { rememberMe: boolean }>) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;

      if (state.accessToken)
        window.sessionStorage.setItem('accessToken', state.accessToken)

      if (state.refreshToken) {
        if (payload.rememberMe) {
          window.localStorage.setItem('refreshToken', state.refreshToken)
        }
        else {
          window.sessionStorage.setItem('refreshToken', state.refreshToken)
          window.localStorage.removeItem('refreshToken')
        }
      }
    },
  },
})

export const { logout, refresh } = authSlice.actions

export default authSlice.reducer